var EHDI = EHDI || Object.create(null);

EHDI.game = EHDI.game || Object.create(null);

EHDI.game.Animation = function () {
}

EHDI.game.Animation.prototype.init = function (animationPath) {
  this._animationPath = animationPath;
  this._skeletonData;

  this._factory;
  this._armature;

  this._animationFactory = EHDI.GetAnimationFactory();

  this._animationFactory.addAnimation(animationPath);

  if (this._skeletonData == null) {
    this._skeletonData = EHDI.Assets.fetch(animationPath + "_anim_ske");
  }

  if (this._factory == null) {
    this._factory = this._animationFactory .getFactory();
  }

  if (this._armature == null) {
    this._armature = this._factory.buildArmature(this._skeletonData.armature[0].name);
    dragonBones.WorldClock.clock.add(this._armature);
  }
}

EHDI.game.Animation.prototype.getArmature = function () {
  return this._armature;
}

EHDI.game.Animation.prototype.changeAnimation = function (animationName) {
  if (this._armature.animation.movementID != this._animationPath + '_' +animationName)
    this._armature.animation.gotoAndPlay(this._animationPath + '_' +animationName);
}

EHDI.game.Animation.prototype.play = function () {
  this._armature.animation.play();
}

EHDI.game.Animation.prototype.stop = function () {
  this._armature.animation.stop();
}

EHDI.game.Animation.prototype.getDisplay = function () {
  return this._armature.getDisplay();
}

EHDI.game.Animation.prototype.destroy = function () {
  if (this._armature != null) {
    if (this._armature.getDisplay().parent != null)
      this._armature.getDisplay().parent.removeChild(this._armature.getDisplay());
    this._armature.animation.stop();
    dragonBones.WorldClock.clock.remove(this._armature);
    this._armature.dispose();
    this._armature = null;
  }

  if (this._factory != null) {
    this._factory = null;
  }

  if (this._skeletonData != null) {
    this._skeletonData = null;
  }

  this._animationPath = null;
  this._animationFactory = null;
}

EHDI.game.Animation.prototype.reset = function () {
  if (this._armature != null) {
    if (this._armature.getDisplay().parent != null)
      this._armature.getDisplay().parent.removeChild(this._armature.getDisplay());
    this._armature.animation.stop();
    dragonBones.WorldClock.clock.remove(this._armature);
    this._armature.dispose();
    this._armature = null;
  }

  // if (this._factory != null) {
  //   this._factory.dispose();
  //   this._factory = null;
  // }

  // if (this._textureData != null)
  //   this._textureData = null;

  if (this._skeletonData != null)
    this._skeletonData = null;
  //
  // if (this._textureImage != null)
  //   this._textureImage = null;
}
